// extracted by mini-css-extract-plugin
export default {"contentStyle":"DisableCampaignModal_contentStyle__L9AJr","container":"DisableCampaignModal_container__+H6i4","footer":"DisableCampaignModal_footer__Pg7IU"};